/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import { SearchOutlined } from '@ant-design/icons';
import Select from 'components/Select';
import {
  Badge,
  Button,
  Calendar,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  TimePicker,
  Typography,
} from 'antd';
import { getCandidatovistaOptimized } from 'api/catalogos/Candidatos';
import { getCitas, patchCita } from 'api/reclutamiento/citas';
import FormSubmitControls from 'components/FormSubmitControls';
import { checkToken } from 'api/utils';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { onError } from 'utils/handlers';
import { getCitasEstado } from 'api/reclutamiento/estadosCitas';
import HistoricoCitas from './CitasHistorico';

const { Title } = Typography;
// Construye los paths concatenados

export default function CitasParaHistoricoCandidatos({ candidatoID }) {
  const [form] = Form.useForm();

  const [date, setDate] = useState(moment());
  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editingCita, setEditingCita] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [selectedCita, setSelectedCita] = useState(null);
  const [cancelForm] = Form.useForm();
  const [attendForm] = Form.useForm();
  const [visibleAtendido, setVisibleAtendido] = useState(false);
  const [estadosCitas, setEstadosCitas] = useState([]);

  const [citas, setCitas] = useState([]);
  // Adaptador para transformar el formato de citas recibido
  async function adaptarCitas(rawCitas, candidatosVista) {
    if (!rawCitas || !Array.isArray(rawCitas)) return [];

    return rawCitas.map((cita) => {
      const candidatoData = candidatosVista.find((c) => c.id === cita.candidato);

      return {
        id: cita.id,
        folio: cita.folio,
        fecha: cita.fecha,
        horario: cita.horario,
        estado_de_cita: cita.estado_de_cita,
        atendida: cita.atendida,
        comentarios: cita.comentarios,

        // Info básica del candidato
        candidatoId: candidatoData?.id,
        candidatoNombre: candidatoData?.candidato_numero_y_nombre_completo,

        // Info de solicitante
        solicitanteNombre: candidatoData?.solicitante,
        solicitantePlaza: candidatoData?.solicitante_plaza_clave_y_descripcion,
        solicitantePuesto: candidatoData?.solicitante_puesto_clave_y_descripcion,
        solicitanteArea: candidatoData?.solicitante_directorio_de_area_clave_y_nombre,

        // Info de vacante
        vacantePlaza: candidatoData?.vacante_plaza_clave_y_descripcion,
        vacantePuesto: candidatoData?.vacante_puesto_clave_y_descripcion,
        vacanteArea: candidatoData?.vacante_directorio_de_area_clave_y_nombre,
      };
    });
  }

  const fetchData = async () => {
    setLoading(true);
    try {
      const [_citas, _candidatosVista] = await Promise.all([
        getCitas({ candidato: candidatoID }),
        getCandidatovistaOptimized({ id: candidatoID }),
      ]);
      if (Array.isArray(_citas)) {
        const citasAdaptadas = await adaptarCitas(_citas, _candidatosVista);
        setCitas(citasAdaptadas);
        const _date = citasAdaptadas[0].fecha ? moment(citasAdaptadas[0].fecha) : moment();
        setDate(_date);
      } else {
        setCitas([]);
      }
    } catch (err) {
      setCitas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        // Primero obtenemos las solicitudes
        const [
          // _estados,
          _estadosCitas,
        ] = await Promise.all([
          // getEstadosGlobales(),
          getCitasEstado(),
        ]);

        if (mounted) {
          // Asignamos el resto de los datos
          // setEstados(_estados);
          setEstadosCitas(_estadosCitas);
        }
      } catch (error) {
        onError(error, 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    fetchData();
  }, [candidatoID]);

  const selectedDate = date.format('YYYY-MM-DD');
  const citasCoincidenBusqueda = (citas || []).filter((cita) => {
    const valores = `${cita.fecha} ${cita.vacantePlaza} ${cita.vacantePuesto} ${cita.solicitanteNombre} ${cita.candidatoNombre} ${cita.vacanteAreaNombre} ${cita.vacanteAreaCodigo} ${cita.vacanteCodigo} ${cita.vacantePuestoCodigo}`;
    return valores.toLowerCase().includes(search.toLowerCase());
  });

  const mostrarCitas = search.length > 0
    ? citasCoincidenBusqueda
    : (citas || []).filter((c) => c.fecha === selectedDate);

  const dateCellRender = (value) => {
    const currentDate = value.format('YYYY-MM-DD');
    const citasCount = (citas || []).filter((c) => c.fecha === currentDate).length;
    return citasCount > 0 ? (
      <div style={{ textAlign: 'center' }}>
        <Badge count={citasCount} style={{ backgroundColor: '#1890ff' }} />
      </div>
    ) : null;
  };

  const abrirModalReagendar = (cita) => {
    setEditingCita(cita);

    form.setFieldsValue({
      ...cita,
      fecha: cita.fecha ? moment(cita.fecha, 'YYYY-MM-DD') : null,
      horario: cita.horario ? moment(cita.horario, 'HH:mm:ss') : null,
      estado_de_cita: 2, // <-- Forzar estado en REAGENDADA
      vacanteAreaNombre: cita.vacanteArea,
      candidato: cita.candidatoId,
    });

    setModalVisible(true);
  };

  const onConfirmCancelar = async (values) => {
    try {
      setLoading(true);

      if (!selectedCita) {
        setLoading(false);
        setVisibleCancelar(false);
        return;
      }

      const res = await patchCita(selectedCita.id, {
        estado_de_cita: 5, // CANCELADA
        comentarios: values.comentarios ?? '',
        fecha_de_cancelacion: null, // <- backend pondrá la fecha actual
        fecha_y_hora_cancelacion: null, // <- backend pondrá la hora actual
      });

      if (res) {
        await fetchData();
        setVisibleCancelar(false);
        setSelectedCita(null);
        form.resetFields(); // limpia comentarios y los campos display
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmAtendida = async (values) => {
    try {
      setLoading(true);

      if (!selectedCita) {
        setLoading(false);
        setVisibleAtendido(false);
        return;
      }

      const res = await patchCita(selectedCita.id, {
        estado_de_cita: 3, // ATENDIDA
        comentarios: values.comentarios ?? '',
      });

      if (res) {
        await fetchData();
        setVisibleAtendido(false);
        setSelectedCita(null);
        attendForm.resetFields(); // limpiar
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  return (
    <div>
      <Spin tip="Cargando..." spinning={loading}>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <Title level={3}>Calendario de Citas Del Candidato</Title>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col xs={24} md={16}>
            <Calendar
              value={date}
              onSelect={(value) => setDate(value)}
              dateCellRender={dateCellRender}
            />
          </Col>

          <Col xs={24} md={8}>
            <Title level={4} style={{ marginBottom: 8 }}>
              {search.length > 0
                ? `Resultados de búsqueda (${mostrarCitas.length})`
                : `Citas del ${date.format('LL')}`}
            </Title>

            <Input
              prefix={<SearchOutlined />}
              placeholder="Buscar en todas las citas..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Card bodyStyle={{ padding: 12 }}>
              {mostrarCitas.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {mostrarCitas.map((cita) => (
                    <Card key={cita.id} size="small" bordered>
                      <Title level={5} style={{ margin: 0 }}>
                        Folio:
                        {' '}
                        {cita.folio}
                      </Title>

                      <div>
                        <strong>Fecha:</strong>
                        {' '}
                        {moment(cita.fecha).format('LL')}
                      </div>

                      <div>
                        <strong>Hora:</strong>
                        {' '}
                        {cita.horario ? moment(cita.horario, 'HH:mm:ss').format('HH:mm') : ''}
                      </div>

                      <div>
                        <strong>Candidato:</strong>
                        {' '}
                        {cita.candidatoNombre}
                      </div>

                      <div>
                        <strong>Solicitante:</strong>
                        {' '}
                        {cita.solicitanteNombre}
                      </div>

                      <div>
                        <strong>Vacante:</strong>
                        {' '}
                        {cita.vacantePlaza}
                        {' '}
                        /
                        {' '}
                        {cita.vacantePuesto}
                      </div>

                      <div>
                        <strong>Área:</strong>
                        {' '}
                        {cita.vacanteArea}
                      </div>

                      <div>
                        <strong>Estado:</strong>
                        {' '}
                        {estadosCitas.find((e) => e.id === cita.estado_de_cita)?.descripcion
                          || cita.estado_de_cita}
                      </div>

                      <div style={{
                        display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8,
                      }}
                      >
                        <Button
                          type="default"
                          style={{ fontWeight: 'bold', width: '100%' }}
                          onClick={() => abrirModalReagendar(cita)}
                        >
                          Ver Cita
                        </Button>
                      </div>

                    </Card>

                  ))}
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: 32, color: '#999' }}>
                  No hay coincidencias.
                </div>
              )}
            </Card>
          </Col>
        </Row>

        <Modal
          open={modalVisible}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={600}
          title={(
            <FormSubmitControls
              label="Ver Cita"
              onCancel={() => setModalVisible(false)}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => setModalVisible(false)}
        >
          <Form form={form} layout="vertical">
            <Row gutter={16}>
              <Col xs={24} sm={12}><Form.Item label="Fecha" name="fecha" rules={[{ required: true }]}><DatePicker style={{ width: '100%' }} disabled /></Form.Item></Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Hora"
                  name="horario"
                  rules={[{ required: true, message: 'La hora es obligatoria' }]}
                >
                  <TimePicker format="HH:mm" style={{ width: '100%' }} disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                {/* Campo oculto que guarda el ID del candidato */}
                <Form.Item name="candidato" hidden>
                  <Input />
                </Form.Item>

                {/* Campo visible solo de lectura con el nombre */}
                <Form.Item label="Candidato" name="candidatoNombre">
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}><Form.Item label="Área" name="vacanteAreaNombre"><Input disabled /></Form.Item></Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  label="Puesto"
                  name="vacantePuesto"
                >
                  <Input disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Plaza" name="vacantePlaza">
                  <Select
                    keyProp="id"
                    labelProp="clave_y_descripcion"
                    // dataSource={plazas}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}><Form.Item label="Solicitante" name="solicitanteNombre"><Input disabled /></Form.Item></Col>

              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  label="Estado de la Cita"
                  name="estado_de_cita"
                  // rules={[{ required: true, message: 'El estado es obligatorio' }]}
                  hasFeedback
                  initialValue={1}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estadosCitas}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Observaciones"
                  name="comentarios"

                >
                  <Input.TextArea rows={3} disabled />
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12}>
                <Form.Item
                  label="Estado de la Cita"
                  name="estado_de_cita"

                >
                  <Select placeholder="Selecciona un estado">
                    {estadosCitas.map((estado) => (
                      <Select.Option key={estado.id} value={estado.id}>
                        {estado.descripcion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
              <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />

            </Row>
          </Form>
        </Modal>
        <Modal
          open={visibleCancelar}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={500}
          title={(
            <FormSubmitControls
              label="Cancelar Cita"
              onFinish={() => cancelForm.submit()}
              onCancel={() => setVisibleCancelar(false)}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => setVisibleCancelar(false)}
        >
          <Form form={cancelForm} layout="vertical" onFinish={onConfirmCancelar}>
            {/* Fecha de cancelación (solo display) */}
            <Form.Item label="Fecha de cancelación" name="fecha_cancelacion_display">
              <Input disabled />
            </Form.Item>

            {/* Hora de cancelación (solo display) */}
            <Form.Item label="Hora de cancelación" name="hora_cancelacion_display">
              <Input disabled />
            </Form.Item>

            {/* Observaciones */}
            <Form.Item
              label="Observaciones"
              name="comentarios"
              rules={[{ required: true, message: 'Por favor escribe el motivo de la cancelación' }]}
            >
              <Input.TextArea rows={3} placeholder="Escribe el motivo de la cancelación" />
            </Form.Item>
            <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />
          </Form>
        </Modal>

        <Modal
          open={visibleAtendido}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width={500}
          title={(
            <FormSubmitControls
              label="Marcar como Atendida"
              onFinish={() => attendForm.submit()}
              onCancel={() => setVisibleAtendido(false)}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => setVisibleAtendido(false)}
        >
          <Form form={attendForm} layout="vertical" onFinish={onConfirmAtendida}>
            {/* Solo comentarios */}
            <Form.Item
              label="Observaciones"
              name="comentarios"
              rules={[{ required: false }]}
            >
              <Input.TextArea rows={3} placeholder="Escribe observaciones de la atención" />
            </Form.Item>
            <HistoricoCitas citaId={editingCita?.id || selectedCita?.id || null} />
          </Form>
        </Modal>

      </Spin>
    </div>
  );
}
